module.exports = __webpack_public_path__ + "img/dov_no.3b57fc68.png";